import moment from 'moment';
import Confirm from '@/components/confirm.vue'
import BookingAddForm from '@/components/booking/add.vue'
import BookingEditForm from '@/components/booking/edit.vue'
import BookingDetails from '@/components/booking/details.vue'
import TicketsMixin from '@/mixins/tickets'
export default {
  mixins: [TicketsMixin],
  components: {
    'm-confirm': Confirm,
    'm-booking-add-form': BookingAddForm,
    'm-booking-details': BookingDetails,
    'm-booking-edit-form': BookingEditForm
  },
  data () {
    return {
      form: {
        dates: [],
        back: false,
        fields: {}
      },
      menu_date_start: false,
      menu_date_end: false,
      dialog: false,
      dialog_ticket: false,
      dialog_edit: false,
      dialog_details: false,
      dialog_booking: false,
      selectedItem: {},
      // date_start: moment().startOf('month').format('YYYY-MM-DD'),
      date_start: moment().format('YYYY-MM-DD'),
      date_end: moment().format('YYYY-MM-DD'),
      dateFormatted_start: null,
      dateFormatted_end: null,
      dateFormatted: null,
      ticketUrl: null,
      loadingBookings: false
    }
  },
  methods: {
    formatDate (date) {
      if (!date) {
        return null
      }
      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    moment: function (d) {
      return moment(d);
    },
    resetBooking () {
      this.form = {
        dates: [],
        back: false,
        fields: {}
      };
    },
    onRefresh () {
      console.log('bookings onRefresh');
      this.getData();
    },
    onCloseBooking (data) {
      this.dialog = false;
      this.dialog_edit = false;
      this.dialog_details = false;
      this.dialog_booking = false;
      // this.reset();
      // console.log('close');
    },
    viewTicket (item) {
      this.getTickets(item.id).then((result) => {
        if (result[0]) {
          this.ticketUrl = result[0].imageUrl;
          this.dialog_ticket = true;
        }
      });
    },
    onSaveBooking (data) {
      console.log('mixin onSaveBooking', data);
      // var app = this;
      var api = 'service/booking/addRecursive';
      this.$http
      .post(api, data)
      .then(response => {
        this.resetBooking();
        this.onRefresh();
        this.onCloseBooking();
        // app.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    onUpdateBooking (data) {
      // var app = this;
      var id = this.selectedItem.id;
      this.$http
      .put('api/booking/' + id, data)
      .then(response => {
        this.resetBooking();
        this.onRefresh();
        this.onCloseBooking();
        // app.items = response.data;
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    deleteBooking (item, callback) {
      this.$http
      .delete('api/booking/' + item.id)
      .then(response => {
        if (callback) {
          callback();
        }
        this.onRefresh();
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    },
    getBooking (id, callback) {
      var app = this;
      this.$http
      .get('api/booking/' + id)
      .then(response => {
        var d = response.data[0];
        var distance = d.json = JSON.parse(d.distance)
        d.ap_date = app.$options.filters.date(d.ap_date)
        d.price = d.price || distance.totals[d.type].price
        d.dist = distance.totals[d.type].distance
        d.duration = app.$options.filters.toTime(distance.totals[d.type].duration)
        callback(d);
      })
      .catch(function (error) {
        console.log('catch:', error);
      });
    }
  },
  filters: {
    date: function (date) {
      return moment(date).format('DD/MM/YYYY');
    },
    formatIndex (v, obj) {
      return obj[v];
    },
    toTime (sec) {
      var time;
      if (sec > 3600) {
        time = new Date(sec * 1000).toISOString().substr(11, 5) + ' h'
      } else {
        time = new Date(sec * 1000).toISOString().substr(14, 2) + ' mins'
      }
      return time;
    }
  }
}
